import { FormHorizontal } from '~/components/form/layout';
import { TenantPerformableFormProps } from '~/tenants/common/form';
import { TenantPerformableConfiguration } from '~/tenants/common/performable';
import { MlmOrderContext } from '../../model/MlmOrder';
import ZodFieldSelect from '~/components/zod/ZodFieldSelect';
import { MlmHeadshotType } from '~/tenants/mlm/performable/headshot/MlmHeadshotConfig';
import { useZodFormFieldSingleValue } from '~/components/zod/ZodForm';
import ZodFieldTextarea from '~/components/zod/ZodFieldTextarea';
import { MLM_HEADSHOT_PEOPLE } from '~/tenants/mlm/performable/headshot/MlmHeadshotJob';

export default function MlmHeadshotForm(_props: TenantPerformableFormProps<MlmOrderContext>) {
  const type = useZodFormFieldSingleValue<MlmHeadshotType>('type');

  return (
    <TenantPerformableConfiguration>
      <FormHorizontal name="type" label="Location">
        <ZodFieldSelect
          name="type"
          options={[
            { label: 'At MLM Studio', value: MlmHeadshotType.STUDIO },
            { label: 'On Location', value: MlmHeadshotType.LOCATION },
          ]}
        />
      </FormHorizontal>
      {type === MlmHeadshotType.LOCATION && (
        <>
          <FormHorizontal name="people" label="People">
            <ZodFieldSelect
              name="people"
              options={Object.keys(MLM_HEADSHOT_PEOPLE).map((people) => ({
                label: `${people} People`,
                value: people,
              }))}
            />
          </FormHorizontal>
          <FormHorizontal label="Parking" name="parking">
            <ZodFieldTextarea name="parking" />
          </FormHorizontal>
        </>
      )}
    </TenantPerformableConfiguration>
  );
}
